const useEnv = () => {
    const isDevelopment = process.env.NODE_ENV === 'development';
    const projectId = process.env.NEXT_PUBLIC_PROJECT_ID;
    return { isDevelopment, isProduction: !isDevelopment, projectId };
};

export default useEnv;
